import React from 'react';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Panel,
  Checkbox,
  Row
} from "react-bootstrap";

import {educationLevel, statusTypes} from "../config/constants";

const OtherInfoStatic = (props) => {
  const {
    sjdcEops,
    otherEops,
    sjdcDsps,
    motherEdLevel,
    fatherEdLevel,
    motherLanguage,
    fatherLanguage,
    fosterYouth,
    veteran,
    headOfHousehold,
    ab540,
    cashAid,
    calworks,
    dependents
  } = props;
  const fatherEdValue = educationLevel.find((option) => option.value === fatherEdLevel);
  const fatherEdText = fatherEdValue ? fatherEdValue.text : 'Unknown';
  const motherEdValue = educationLevel.find((option) => option.value === motherEdLevel);
  const motherEdText = motherEdValue ? motherEdValue.text : 'Unknown';

  return (
    <Panel bsStyle={statusTypes.INFO}>
      <Panel.Heading>Other Information</Panel.Heading>
      <Panel.Body>
        <Row>
          <Col md={6}>
            <Checkbox
              checked={sjdcEops}
              readOnly
            >
              I have participated in EOPS at SJDC
            </Checkbox>
            <Checkbox
              checked={otherEops}
              readOnly
            >
              I have participated in EOPS at another college
            </Checkbox>
            <Checkbox
              checked={sjdcDsps}
              readOnly
            >
              I am currently enrolled in SJDC's Disability Support Programs and Services (DSPS)
            </Checkbox>
            <Checkbox
              checked={fosterYouth}
              readOnly
            >
              I am a recently emancipated foster youth (age 18-24)
            </Checkbox>
            <Checkbox
              checked={ab540}
              readOnly
            >
              I am an AB540 student
            </Checkbox>
          </Col>
          <Col md={6}>
            <Checkbox
              checked={veteran}
              readOnly
            >
              I am a veteran
            </Checkbox>
            <Checkbox
              checked={headOfHousehold}
              readOnly
            >
              I am a single parent/head of household
            </Checkbox>
            <Checkbox
              checked={cashAid}
              readOnly
            >
              I am receiving cash aid/TANF
            </Checkbox>
            <Checkbox
              checked={calworks}
              readOnly
            >
              I am receiving CalWORKs
            </Checkbox>
            <FormGroup
              controlId='dependents'>
              <ControlLabel>
                Number of dependent children under 14 years of age
              </ControlLabel>
              <FormControl.Static>
                {dependents}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup controlId='mother-ed-level'>
              <ControlLabel>Mother's Highest Education Level</ControlLabel>
              <FormControl.Static>
                {motherEdText}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup controlId='mother-language'>
              <ControlLabel>
                Mother's First Language
              </ControlLabel>
              <FormControl.Static>
                {motherLanguage}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup controlId='father-ed-level'>
              <ControlLabel>Father's Highest Education Level</ControlLabel>
              <FormControl.Static>
                {fatherEdText}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup controlId='father-language'>
              <ControlLabel>Father's First Language</ControlLabel>
              <FormControl.Static>
                {fatherLanguage}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
      </Panel.Body>
    </Panel>
  )
};

export default OtherInfoStatic